import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader, ScrollText, FileCheck2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import { fmt } from "../lib/utils";
import Avatar from "./common/Avatar";

export default function ContractsView() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [contracts, setContracts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/portfolio/contracts")
      .then(r => setContracts(r.data.contracts || []))
      .catch(() => setContracts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center py-32"><Loader className="w-6 h-6 animate-spin text-faint" /></div>
  );

  return (
    <div className="animate-fade-up">
      <div className="mb-6">
        <h1 className="text-greeting text-night">{t("nav.kontrakter")}</h1>
        <p className="text-[13.5px] text-muted mt-1">{t("contracts.subtitle", { count: contracts.length })}</p>
      </div>

      {contracts.length === 0 ? (
        <div className="cx-card p-12 text-center">
          <ScrollText className="w-8 h-8 text-faint mx-auto mb-3" />
          <p className="text-[15px] font-bold text-night">{t("contracts.empty")}</p>
          <p className="text-[13px] text-muted mt-1 mb-4">{t("contracts.empty_sub")}</p>
          <button onClick={() => navigate("/settings")} className="cx-btn-dark mx-auto">{t("portfolio.ga_til_innstillinger")}</button>
        </div>
      ) : (
        <div className="cx-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-line">
                  <th className="cx-th">{t("contracts.col_vendor")}</th>
                  <th className="cx-th">{t("contracts.col_project")}</th>
                  <th className="cx-th">{t("contracts.col_type")}</th>
                  <th className="cx-th text-right">{t("contracts.col_value")}</th>
                  <th className="cx-th text-center">{t("contracts.col_doc")}</th>
                </tr>
              </thead>
              <tbody>
                {contracts.map((c: any, i: number) => (
                  <tr key={c.id} className={`${i > 0 ? "border-t border-line" : ""} hover:bg-canvas transition-colors`}>
                    <td className="cx-td">
                      <div className="flex items-center gap-2.5">
                        <Avatar name={c.vendor_name || "?"} size="sm" />
                        <span className="font-semibold truncate">{c.vendor_name || "—"}</span>
                      </div>
                    </td>
                    <td className="cx-td text-muted">{c.project_name}</td>
                    <td className="cx-td">
                      <span className="cx-chip bg-black/[0.05] text-muted">{c.contract_type || "—"}</span>
                    </td>
                    <td className="cx-td text-right font-bold tabular">{fmt(c.total_value, c.currency)}</td>
                    <td className="cx-td text-center">
                      {c.has_pdf
                        ? <FileCheck2 className="w-4 h-4 text-pos inline" />
                        : <span className="text-faint text-[12px]">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
